import React, { memo } from "react";
import { makeStyles } from "@material-ui/core";

import { Text, View } from "../../../Base";
import { LocationIcon, ParcelIcon } from "../../../icons";
import palette from "../../../styles/palette";

const useStyles = makeStyles(({ typography }) => ({
  container: {
    marginBottom: typography.pxToRem(7),
  },
  section: {
    display: "flex",
    flexDirection: "row",
  },
  icon: {
    marginRight: typography.pxToRem(3.11),

    "& svg": {
      fill: palette.yellow,
      maxHeight: typography.pxToRem(10),
      maxWidth: typography.pxToRem(10),
    },
  },
  title: {
    color: "white",
    fontSize: typography.pxToRem(12),
  },
}));

const Forecasts = ({ parcels, stops }) => {
  const classes = useStyles();

  return (
    <View className={classes.container}>
      <View className={classes.section}>
        <View className={classes.icon}>
          <LocationIcon />
        </View>
        <Text className={classes.title} data-testid="route-forecastStops">
          {`${stops}`.padStart(3, 0)}
        </Text>
      </View>
      <View className={classes.section}>
        <View className={classes.icon}>
          <ParcelIcon />
        </View>
        <Text className={classes.title} data-testid="route-forecastParcels">
          {`${parcels}`.padStart(3, 0)}
        </Text>
      </View>
    </View>
  );
};

export default memo(Forecasts);
